<template>
  <div class="content">
    <div class="head">
      <div class="container">
        <div class="row">
          <img class="logoImg" src="../assets/img/logo.png">
        </div>
      </div>
    </div>

    <div class="login">
      <div class="container">
        <div class="row">
          <h2>クラスコードを入力してください</h2>
          <form @submit.prevent="classCoad">
            <input type="number" v-model="pass">
            <div v-if="err">
              "クラスコードが違います"
            </div>
            <div>
              <button type="button" @click="classCoad" class="submitButton">OK</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  name: 'selectClass',
  data() {
    return{
    pass: '',
    err: false
    };
  },
  created(){
  },
  methods:{
    classCoad: function(){
      var self = this;
      axios.get(self.$store.state.APIbase + 'api/auth/' + self.pass)
        .then((res) => {
          if(res.data.length){
            self.err = false;
            self.$store.state.loggedIn = true;
            this.$router.push({ name: 'login', params: { classNum: res.data[0].classNum} });
          }else{
            self.err = true;
          }
        });
    },
  }
}
</script>

<style scoped>
.head{
  width: 100%;
  height: 150px;
  min-height: 30px;
  background: #4690CF;
  text-align: center;
}
.logoImg{
  width: 200px;
  margin-top: 0;
}
.login{
  padding-top: 20px;
  background: rgb(238, 247, 255);
  box-shadow: 0px -4px 2px rgba(0,0,0,.5);
  text-align: center;
}
.button{
  padding-top: 10px;
  padding-bottom: 40px;
  transition: all .3s;
}
@media (min-width: 700px) {
  .button{
    margin-left: 0;
    margin-right: 3%;
  }
}
.button:hover{
  transform: scale(1.1);
}
.button:active{
  transform: scale(.9);
}
.inUse{
  background: rgb(5, 62, 112);
  color: white;
  border: none;
}
.inUse:hover{
  border: none;
  transform: scale(1.0);
}

.notice{
  position: fixed;
  top: 10%;
  width: 90%;
  margin-left: 5%;
  padding: 5px;
  background: rgb(233, 255, 221);
  transition: all 1.2s;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity 1.2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
